<template>
  <div v-wechat-title="title" style="height:100%">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>

  </div>
</template>

<script>
export default {
    name: `DeptMgt`,
    props: {

    },
    data() {
        return {
            title: `科室管理`
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DeptMgt/Index.vue